'use strict';

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

window.bootstrap = bootstrap;

export const translations = {};

export function isParcelPage() {
  return document.querySelector('.parcel-new-page, .parcel-detail-page') !== null;
}

export function initBootstrapComponents() {
  $('.parcel-new-page [data-bs-toggle="dropdown"]').each(function () {
    bootstrap.Dropdown.getOrCreateInstance(this);
  });
  $('.parcel-new-page [data-bs-toggle="popover"]').each(function () {
    const existing = bootstrap.Popover.getInstance(this);
    if (existing) existing.dispose();
    new bootstrap.Popover(this);
  });
}

$(function () {
  const $parcel = $('.parcel-new-page, .parcel-detail-page');
  if (!$parcel.length) return;

  if (typeof $.nette !== 'undefined' && !window.__parcelNetteInitialized) {
    window.__parcelNetteInitialized = true;
    $.nette.init();
  }

  Object.assign(translations, {
    search:           $parcel.data('translation-search'),
    error:            $parcel.data('translation-error'),
    success:          $parcel.data('translation-success'),
    fillDateTime:     $parcel.data('translation-fill-date-time'),
    connectionFailed: $parcel.data('translation-connection-failed'),
    waiting:          $parcel.data('translation-waiting'),
  });

  initBootstrapComponents();
});
